import { Navigate, useLocation } from 'react-router-dom';
import { CodeSignIn } from '../components/CodeSignIn.js';
import { safeReturnTo } from '../lib/returnTo.js';
import { useSessionContext } from '../lib/session.js';

/**
 * Sign-in: an email, then a six-digit code sent to it (D-066). No passwords,
 * no Google. There is no "create an account" either: a code goes only to an
 * existing account's address or an active Jobber user's, and the API decides
 * which, answering alike for any address.
 *
 * Once a session exists this page is not for you: it sends you where you were
 * going (a deep link that hit `RequireAuth`), or home. The code is entered on
 * this page, so where you were going never leaves the router's state.
 */
export function SignInPage() {
  const { session } = useSessionContext();
  const location = useLocation();
  const from = safeReturnTo((location.state as { from?: string } | null)?.from);

  if (session) return <Navigate to={from} replace />;

  return (
    <main className="signin">
      {session === undefined ? <p className="text-muted">Checking your session…</p> : <CodeSignIn title="Sign in with your work email." />}
    </main>
  );
}
